import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ViewEncapsulation } from '@angular/core';
import * as $ from "jquery";
import { SessionService } from '../../shared/services/session.service';

@Component({
  selector: 'app-yr3-st-memorygame',
  templateUrl: './yr3-st-memorygame.component.html',
  styleUrls: ['./yr3-st-memorygame.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class Yr3StMemorygameComponent implements OnInit {
  public bloburl: string;

  constructor(private sessionService: SessionService, public thisDialogRef: MatDialogRef<Yr3StMemorygameComponent>, @Inject(MAT_DIALOG_DATA) public data: string) {

    this.bloburl = this.sessionService.bloburl;
  }

  ngOnInit() {

    var main_src = "/Lasresan/AK3/YR3-StudentsWeb/Tincan/memorygame/frame.png";

    $('<img>').on('load', imageLoaded).attr('src', main_src);
    function imageLoaded() {
      var dashedrect = document.getElementById("dashedrect");
      dashedrect.style.display = "block";
    }

    this.commonfunc(0);
    this.changeColor(0, 1,2);
  }

  changeColor(i, j, k) {

    var e1 = document.getElementById("circle1");
    var e2 = document.getElementById("circle2");
    var e3 = document.getElementById("circle3");

    var c1 = window.getComputedStyle(e1).backgroundColor;
    var c2 = window.getComputedStyle(e2).backgroundColor;
    var c3 = window.getComputedStyle(e3).backgroundColor;

    var circlearr: any[string];
    circlearr = [e1, e2, e3];

    var circlearr1: any[string];
    circlearr1 = [c1, c2, c3];  

    if (circlearr1[i] === "rgb(255, 255, 255)") {
      circlearr[i].style.background = "#ED8505";      
    }
    circlearr[j].style.background = "#FFFFFF";
    circlearr[k].style.background = "#FFFFFF";   
  }


  commonfunc(s) {
    var bloburl = this.sessionService.bloburl;
    startexercise(s);
    var cheersound: any[string];
    cheersound = new Array(34);
    for (var i = 0; i < 34; i++) {
      cheersound[i] = new Audio();
      cheersound[i].src = bloburl + '/Lasresan/AK3/YR3-StudentsWeb/Tincan/cheerssound/audio' + i + '.mp3';
    }

    function shuffle(obj1, obj2) {
      var index = obj1.length;
      var rnd, tmp1, tmp2;

      while (index) {
        rnd = Math.floor(Math.random() * index);
        index -= 1;
        tmp1 = obj1[index];
        tmp2 = obj2[index];
        obj1[index] = obj1[rnd];
        obj2[index] = obj2[rnd];
        obj1[rnd] = tmp1;
        obj2[rnd] = tmp2;
      }
    }

    function getUnique(array) {
      var uniqueArray = [];
      for (i = 0; i < array.length; i++) {
        if (uniqueArray.indexOf(array[i]) === -1) {
          uniqueArray.push(array[i]);
        }
      }
      return uniqueArray;
    }


    function startexercise(s) {


      var sb: any = [0, 1, 2, 3, 4, 5, 6,
        7, 8, 9, 10, 11, 12, 13,
        14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27,
        28, 29, 30, 31, 32, 33, 34,
        35, 36, 37, 38, 39, 40, 41,
        42, 43, 44, 45, 46, 47, 48,
        49, 50, 51, 52, 53, 54, 55,
        56, 57, 58, 59, 60, 61
      ];

      var sb1: any = [0, 1, 2, 3, 4, 5, 6,
        7, 8, 9, 10, 11, 12, 13,
        14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27,
        28, 29, 30, 31, 32, 33, 34,
        35, 36, 37, 38, 39, 40, 41,
        42, 43, 44, 45, 46, 47, 48,
        49, 50, 51, 52, 53, 54, 55,
        56, 57, 58, 59, 60, 61, 62
      ];

      //divide the images into three array from the same folder

      var temparray1:any = [0, 1, 2, 3, 4, 5, 6,
        7, 8, 9, 10, 11, 12, 13,
        14, 15, 16, 17, 18, 19, 20,
        21, 22, 23];

      var temparray2: any = [24, 25, 26, 27, 28, 29,
        30, 31, 32, 33, 34, 35,
        36, 37, 38, 39, 40, 41,
        42, 43, 44, 45, 46, 47
        ];

      var temparray3: any = [48, 49, 50, 51, 52, 53,
        54, 55, 56, 57, 58, 59,
        60, 61, 62, 63, 64, 65,
        66, 67, 68, 69, 70, 71
        ];

      //shuffle the array

      shuffle(temparray1, temparray1);
      shuffle(temparray2, temparray2);
      shuffle(temparray3, temparray3);

      //insert the first three element into last index in the above array

     

      var finalarray: any = [temparray1, temparray2, temparray3];

      shuffle(finalarray, finalarray);

      var sb2: any = [finalarray[0][0], finalarray[0][1], finalarray[0][2], finalarray[0][3], finalarray[0][4],
        finalarray[0][5], finalarray[0][6], finalarray[0][7], finalarray[0][8], finalarray[0][9],
        finalarray[0][10], finalarray[0][11], finalarray[0][12], finalarray[0][13], finalarray[0][14],
        finalarray[0][15], finalarray[0][16], finalarray[0][17], finalarray[0][18], finalarray[0][19],
        finalarray[0][20], finalarray[0][21], finalarray[0][22], finalarray[0][23],


        finalarray[1][0], finalarray[1][1], finalarray[1][2], finalarray[1][3], finalarray[1][4],
        finalarray[1][5], finalarray[1][6], finalarray[1][7], finalarray[1][8], finalarray[1][9],
        finalarray[1][10], finalarray[1][11], finalarray[1][12], finalarray[1][13], finalarray[1][14],
        finalarray[1][15], finalarray[1][16], finalarray[1][17], finalarray[1][18], finalarray[1][19],
        finalarray[1][20], finalarray[1][21], finalarray[1][22], finalarray[1][23],

        finalarray[2][0], finalarray[2][1], finalarray[2][2], finalarray[2][3], finalarray[2][4],
        finalarray[2][5], finalarray[2][6], finalarray[2][7], finalarray[2][8], finalarray[2][9],
        finalarray[2][10], finalarray[2][11], finalarray[2][12], finalarray[2][13], finalarray[2][14],
        finalarray[2][15], finalarray[2][16], finalarray[2][17], finalarray[2][18], finalarray[2][19],
        finalarray[2][20], finalarray[2][21], finalarray[2][22], finalarray[2][23]
      ];

     

      shuffle(sb, sb);
      shuffle(sb1, sb1);
      

      var gamecardcount: any = 0;
      randomcards();

      function randomcards() {

        var myPix: any[string];
        myPix = new Array(62);
        for (var i = 0; i < 62; i++) {
          myPix[i] = new Image();
          myPix[i].src = bloburl + '/Lasresan/AK3/YR3-StudentsWeb/Tincan/memorygame/caps/option1/caps_image' + i + '.png';
        }

        var myPix1: any[string];
        myPix1 = new Array(62);
        for (var i = 0; i < 62; i++) {
          myPix1[i] = new Image();
          myPix1[i].src = bloburl + '/Lasresan/AK3/YR3-StudentsWeb/Tincan/memorygame/small/option1/small_image' + i + '.png';
        }

        var myPix2: any[string];
        myPix2 = new Array(63);
        for (var i = 0; i < 63; i++) {
          myPix2[i] = new Image();
          myPix2[i].src = bloburl + '/Lasresan/AK3/YR3-StudentsWeb/Tincan/memorygame/caps/option2/caps_image' + i + '.png';
        }

        var myPix3: any[string];
        myPix3 = new Array(63);
        for (var i = 0; i < 63; i++) {
          myPix3[i] = new Image();
          myPix3[i].src = bloburl + '/Lasresan/AK3/YR3-StudentsWeb/Tincan/memorygame/small/option2/small_image' + i + '.png';
        }

        var myPix4: any[string];
        myPix4 = new Array(72);
        for (var i = 0; i < 72; i++) {
          myPix4[i] = new Image();
          myPix4[i].src = bloburl + '/Lasresan/AK3/YR3-StudentsWeb/Tincan/memorygame/caps/option3/caps_image' + i + '.png';
        }

        var myPix5: any[string];
        myPix5 = new Array(72);
        for (var i = 0; i < 72; i++) {
          myPix5[i] = new Image();
          myPix5[i].src = bloburl + '/Lasresan/AK3/YR3-StudentsWeb/Tincan/memorygame/small/option3/small_image' + i + '.png';
        }  

        var arraymyPix: any[string];
        arraymyPix = new Array(3);
        arraymyPix = [myPix, myPix2, myPix4];

        var arraymyPix1: any[string];
        arraymyPix1 = new Array(3);
        arraymyPix1 = [myPix1, myPix3, myPix5];

        var shufflesb: any[string];
        shufflesb = new Array(3);
        shufflesb = [sb, sb1, sb2];


        var randomNum1 = shufflesb[s][0 + gamecardcount];
        var randomNum2 = shufflesb[s][1 + gamecardcount];
        var randomNum3 = shufflesb[s][2 + gamecardcount];
        var randomNum4 = shufflesb[s][3 + gamecardcount];
        var randomNum5 = shufflesb[s][4 + gamecardcount];
        var randomNum6 = shufflesb[s][5 + gamecardcount];


        var cardsArray = [{
          'name': 'card1',
          'img': arraymyPix[s][randomNum1].src
        },
        {
          'name': 'card2',
          'img': arraymyPix[s][randomNum2].src
        }, {
          'name': 'card3',
          'img': arraymyPix[s][randomNum3].src
        }, {
          'name': 'card4',
          'img': arraymyPix[s][randomNum4].src
        }, {
          'name': 'card5',
          'img': arraymyPix[s][randomNum5].src
        }, {
          'name': 'card6',
          'img': arraymyPix[s][randomNum6].src
        }, {
          'name': 'card1',
          'img': arraymyPix1[s][randomNum1].src
        }, {
          'name': 'card2',
          'img': arraymyPix1[s][randomNum2].src
        }, {
          'name': 'card3',
          'img': arraymyPix1[s][randomNum3].src
        }, {
          'name': 'card4',
          'img': arraymyPix1[s][randomNum4].src
        }, {
          'name': 'card5',
          'img': arraymyPix1[s][randomNum5].src
        }, {
          'name': 'card6',
          'img': arraymyPix1[s][randomNum6].src
        }
        ];
        var gameGrid = cardsArray.sort(function () {
          return 0.5 - Math.random();
        });

        var firstGuess = '';
        var secondGuess = '';
        var count = 0;
        var previousTarget = null;
        var delay = 1200;

        var game = document.getElementById('game');
        game.innerHTML = "";
        var hiddenbox_grid = document.createElement('div');
        hiddenbox_grid.setAttribute('class', 'hiddenbox_grid');
        game.appendChild(hiddenbox_grid);
        var grid = document.createElement('section');
        grid.setAttribute('class', 'grid');
        game.appendChild(grid);

        gameGrid.forEach(function (item) {
          var name = item.name,
            img = item.img;

          var card = document.createElement('div');
          card.classList.add('card');
          card.dataset.name = name;

          var front = document.createElement('div');
          front.classList.add('front');
          var fullsrc = bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/memorygame/card.png";
          front.style.backgroundImage = 'url(' + fullsrc + ')';


          front.style.backgroundRepeat = 'no-repeat';
          front.style.backgroundSize = '100%';
          front.style.cursor = "pointer";

          var back = document.createElement('div');
          back.classList.add('back');
          back.style.backgroundImage = 'url(' + img + ')';

          card.appendChild(front);
          card.appendChild(back);
          grid.appendChild(card);
        });

        var matchfound = 0;

        var match = function match() {
          //for ie
          var selected = document.getElementsByClassName("selected");
          for (var i = 0; i < selected.length; i++) {
            selected.item(i).classList.add('match');
            var hiddenbox = document.createElement('div');
            hiddenbox.classList.add('hiddenbox');
            selected.item(i).appendChild(hiddenbox);
          }

          if (matchfound < 6) {
            matchfound++;
            if (matchfound == 6) {

              var randomaudio = Math.floor((Math.random() * cheersound.length));
              cheersound[randomaudio].play();

              let newexercise: any = document.createElement('img');
              newexercise.src = bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/memorygame/newexercise.png";
              newexercise.style.display = "block";
              newexercise.id = "newexercise";
              game.appendChild(newexercise);
              newexercise.addEventListener('click', function () {
                newexercise.style.display = "none";
                gamecardcount = gamecardcount + 6;

                if (cheersound.length > 1) {
                  cheersound.splice(randomaudio, 1);
                } else {
                  cheersound = new Array(34);
                  for (var i = 0; i < 34; i++) {
                    cheersound[i] = new Audio();
                    cheersound[i].src = bloburl + '/Lasresan/AK3/YR3-StudentsWeb/Tincan/cheerssound/audio' + i + '.mp3';
                  }
                }

                //for ie
                $("#game").html("");

                if (s == 2) {
                  if (gamecardcount == 72) {
                    shuffle(temparray1, temparray1);
                    shuffle(temparray2, temparray2);
                    shuffle(temparray3, temparray3);
                    shuffle(finalarray, finalarray);
                    gamecardcount = 0;
                    randomcards();
                  }
                  else {
                    randomcards();
                  }
                }

                if (s == 0) {

                  if (gamecardcount == 60) {

                    var lastelement: any = [shufflesb[s][60], shufflesb[s][61]];
                    shuffle(shufflesb[s], shufflesb[s]);
                    shufflesb[s].unshift(lastelement[0], lastelement[1]);
                    shufflesb[s] = getUnique(shufflesb[s]);
                    gamecardcount = 0;
                    randomcards();

                  }
                  else {
                    randomcards();
                  }
                }


                if (s == 1) {

                  if (gamecardcount == 60) {

                    var lastelement: any = [shufflesb[s][60], shufflesb[s][61], shufflesb[s][62]];
                    shuffle(shufflesb[s], shufflesb[s]);
                    shufflesb[s].unshift(lastelement[0], lastelement[1], lastelement[2]);
                    shufflesb[s] = getUnique(shufflesb[s]);
                    gamecardcount = 0;
                    randomcards();

                  }
                  else {
                    randomcards();
                  }
                }                             
              });
            }
          }

        };

       

        var resetGuesses = function resetGuesses() {
          firstGuess = '';
          secondGuess = '';
          count = 0;
          previousTarget = null;

          //for ie
          var selected = document.getElementsByClassName("card");
          for (var i = 0; i < selected.length; i++) {
            selected.item(i).classList.remove("selected");
          }
        };

        grid.addEventListener('click', function (event) {

          let clicked: any = event.target;

          if (clicked.nodeName === 'SECTION' || clicked === previousTarget || clicked.parentNode.classList.contains('selected') || clicked.parentNode.classList.contains('match')) {
            return;
          }

          if (count < 2) {
            count++;
            if (count === 1) {
              firstGuess = clicked.parentNode.dataset.name;              
              clicked.parentNode.classList.add('selected');
            } else {
              secondGuess = clicked.parentNode.dataset.name;              
              clicked.parentNode.classList.add('selected');
            }

            if (firstGuess && secondGuess) {
              if (firstGuess === secondGuess) {
                setTimeout(match, delay);
              }
              setTimeout(resetGuesses, delay);
            }
            previousTarget = clicked;
          }
        });
      }

    }
  }



  onCloseCancel() {   
    this.thisDialogRef.close('Cancel');    
  }


}
